import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import index from '@/view/index'
import home from '@/view/home'
import Yreport from '@/view/Yreport'
import MTHFRreport from '@/view/MTHFRreport'
import item from '@/view/item'
import contact from '@/view/contact'
import aboutCompany from '@/view/aboutCompany'
import report from '@/view/report'
import reportresult from '@/view/reportresult'
import reportresultimg from '@/view/reportresultimg'
import news from '@/view/news'
import gensuniverse from '@/view/gensuniverse'
import gensone from '@/view/gensuniversedetail/gensone'
import genstwo from '@/view/gensuniversedetail/genstwo'
import gensthree from '@/view/gensuniversedetail/gensthree'
import gensfour from '@/view/gensuniversedetail/gensfour'
import gensfive from '@/view/gensuniversedetail/gensfive'
import genssix from '@/view/gensuniversedetail/genssix'
import gensseven from '@/view/gensuniversedetail/gensseven'
import genseight from '@/view/gensuniversedetail/genseight'
import gensnine from '@/view/gensuniversedetail/gensnine'
import gensten from '@/view/gensuniversedetail/gensten'
import genseleven from '@/view/gensuniversedetail/genseleven'
import genstwelve from '@/view/gensuniversedetail/genstwelve'
import gensthirteen from '@/view/gensuniversedetail/gensthirteen'
import gensfourteen from '@/view/gensuniversedetail/gensfourteen'
import gensuniversecate from '@/view/gensuniversecate'
import innategene from '@/view/genedetection/innategene'
import stdfastces from '@/view/genedetection/stdfastces'
import vaccinetest from '@/view/genedetection/vaccinetest'
import cancerrealtime from '@/view/genedetection/cancerrealtime'
import genetictumordetection from '@/view/genedetection/genetictumordetection'
import monogenicdisease from '@/view/genedetection/monogenicdisease'
import paternitytesting from '@/view/genedetection/paternitytesting'


import nonInvasivePrenatalTest from '@/view/genedetection/non-invasive-prenatal-test'
import nonInvasivePrenatalPaternityTest from '@/view/genedetection/non-invasive-prenatal-paternity-test'
import yChromosomeDNATest from '@/view/genedetection/y-chromosome-dna-test'
import mthfr from '@/view/genedetection/mthfr/index'
import steps from '@/view/steps'

// About US
import aboutUs from '@/view/about/about-us'
// 新加fclab简介优化用
import aboutfclab from '@/view/about/about-fclab'
import technology from '@/view/about/technology'
import accreditation from '@/view/about/accreditation'
import media from '@/view/about/media'
import partnership from '@/view/about/partnership'
import career from '@/view/about/career'
import reproductinvhealth from '@/view/reproductinvhealth'
import cancerdescript from '@/view/cancerdescript'
import infectiousdisease from '@/view/infectiousdisease'
import healthylife from '@/view/healthylife'
import terms from '@/view/terms'
import privacy from '@/view/privacy'
import reportoldresult from '@/view/reportoldresult'
import notFound from '@/view/notfound'
Vue.use(Router)

export default new Router({
  
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      redirect: '/home',
      children:[
        {
          path: '/home',
          name: 'home',
          component: home,
        },
        {
          path: '/aboutUs',
          name: 'aboutUs',
          component: aboutUs,
        },
        // 新加FCLAB简介优化用
        {
          path: '/aboutfclab',
          name: 'aboutfclab',
          component: aboutfclab,
        },
        {
          path: '/technology',
          name: 'technology',
          component: technology,
        },
        {
          path: '/accreditation',
          name: 'accreditation',
          component: accreditation,
        },
        {
          path: '/media',
          name: 'media',
          component: media,
        },
        {
          path: '/partnership',
          name: 'partnership',
          component: partnership,
        },
        {
          path: '/career',
          name: 'career',
          component: career,
        },
        {
          path: '/yChromosomeDNATest',
          name: 'yChromosomeDNATest',
          component: yChromosomeDNATest,
        },
      
        {
          path: '/nonInvasivePrenatalTest',
          name: 'nonInvasivePrenatalTest',
          component: nonInvasivePrenatalTest,
        },
        {
          path: '/nonInvasivePrenatalPaternityTest',
          name: 'nonInvasivePrenatalPaternityTest',
          component: nonInvasivePrenatalPaternityTest,
        },
        {
          path: '/mthfr',
          name: 'mthfr',
          component: mthfr,
        },
        {
          path: '/item',
          name: 'item',
          component: item
        },
        {
          path: '/Yreport',
          name: 'Yreport',
          component: Yreport,
          meta:{
            title:'查詢驗證香港卓信化驗所報告_FirstChoice',
            keywords:'香港卓信化验所报告查询,查询香港卓信化验所报告,卓信化验所报告单查询',
            description:'查詢驗證香港卓信化驗所報告,可上卓信官網自助查詢,也可致電報告單上的電話,或郵件查詢,驗證報告或了解更多資訊,歡迎來電(+852)2865 9399'
          }
        },
        {
          path: '/MTHFRreport',
          name: 'MTHFRreport',
          component: MTHFRreport,
          meta:{
            title:'查詢驗證香港卓信化驗所報告_FirstChoice',
            keywords:'香港卓信化验所报告查询,查询香港卓信化验所报告,卓信化验所报告单查询',
            description:'查詢驗證香港卓信化驗所報告,可上卓信官網自助查詢,也可致電報告單上的電話,或郵件查詢,驗證報告或了解更多資訊,歡迎來電(+852)2865 9399'
          }
        },
        {
          path: '/reportoldresult',
          name: 'reportoldresult',
          component: reportoldresult
        },
        
        {
          path: '/contact',
          name: 'contact',
          component: contact,
          meta:{
            title:'加盟香港卓信醫療化驗所_FirstChoice',
            keywords:'香港卓信医疗化验所,香港卓信化验所,怎样加盟卓信化验所,怎样代理香港验血',
            description:'加盟香港卓信化驗所,香港卓信醫療化驗所僅接受來自診所醫生轉介的樣本.如有關化驗所的任何問題,歡迎來電(+852)2865 9399諮詢.'
          }
        },
        {
          path: '/aboutCompany',
          name: 'aboutCompany',
          component: aboutCompany
        },
        {
          path: '/report',
          name: 'report',
          component: report
        },
        {
          path:'/reportresult',
          name:'reportresult',
          component:reportresult
        },
        {
          path: '/news',
          name: 'news',
          component: news
        },
        {
          path: '/gensuniverse',
          name: 'gensuniverse',
          component: gensuniverse
        },
        {  
          path: '/gensone',
          name: 'gensone',
          component: gensone
          
        },
        {  
          path: '/genstwo',
          name: 'genstwo',
          component: genstwo
          
        },
        {  
          path: '/gensthree',
          name: 'gensthree',
          component: gensthree
          
        },
        {  
          path: '/gensfour',
          name: 'gensfour',
          component: gensfour
          
        },
        {  
          path: '/gensfive',
          name: 'gensfive',
          component: gensfive
          
        },
        {  
          path: '/genssix',
          name: 'genssix',
          component: genssix
          
        },
        {  
          path: '/gensseven',
          name: 'gensseven',
          component: gensseven
          
        },
        {  
          path: '/genseight',
          name: 'genseight',
          component: genseight
          
        },
        {  
          path: '/gensnine',
          name: 'gensnine',
          component: gensnine
          
        },
        {  
          path: '/gensten',
          name: 'gensten',
          component: gensten
          
        },
        {  
          path: '/genseleven',
          name: 'genseleven',
          component: genseleven
          
        },
        {  
          path: '/genstwelve',
          name: 'genstwelve',
          component: genstwelve
          
        },
        {  
          path: '/gensthirteen',
          name: 'gensthirteen',
          component: gensthirteen
          
        },
        {
          path: '/gensfourteen',
          name: 'gensfourteen',
          component: gensfourteen
        
        },
        {
          path:'/gensuniversecate',
          name:'gensuniversecate',
          component:gensuniversecate,
        },
        {
          path:'/innategene',
          name:'innategene',
          component:innategene,
        },
        {
          path:'/stdfastces',
          name:'stdfastces',
          component:stdfastces,
        },
        {
          path:'/vaccinetest',
          name:'vaccinetest',
          component:vaccinetest,
        },
        {
          path:'/cancerrealtime',
          name:'cancerrealtime',
          component:cancerrealtime,
        },
        {
          path:'/genetictumordetection',
          name:'genetictumordetection',
          component:genetictumordetection,
        },{
          path:'/monogenicdisease',
          name:'monogenicdisease',
          component:monogenicdisease,
        },{
          path:'/paternitytesting',
          name:'paternitytesting',
          component:paternitytesting,
        },
        {
          path:'/reproductinvhealth',
          name:'reproductinvhealth',
          component:reproductinvhealth,
        },
        {
          path:'/cancerdescript',
          name:'cancerdescript',
          component:cancerdescript,
        },
        {
          path:'/infectiousdisease',
          name:'infectiousdisease',
          component:infectiousdisease,
        },
        {
          path:'/healthylife',
          name:'healthylife',
          component:healthylife,
        },
        {
          path:'/terms',
          name:'terms',
          component:terms,
        },
        {
          path:'/privacy',
          name:'privacy',
          component:privacy,
        },
        {
          path:'/notFound',
          name:'notFound',
          component:notFound,
        },
        
        {
          path:'/steps',
          name:'steps',
          component:steps
        }
      ]
    },
    {
      path:'/reportresultimg',
      name:'reportresultimg',
      component:reportresultimg
    },
    {
      path:'*',
      redirect:'/notFound'
    }
  ],
  scrollBehavior(to,from,savedPosition){
    if(savedPosition){
      return savedPosition;
    }else{
      return {x:0,y:0}
    }
  },

})



// WEBPACK FOOTER //
// ./src/router/index.js